<div class="wrapper" [ngStyle]="style">
  <span [style.font-size]="fontSize" class="initials">{{ initials }}</span>
</div>
